import React from "react";

import { faPaperclip } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { EventExtraData } from "~/calendar/ViewEvent/index";
import { RecordingsIcon } from "~/stream/VideoCallButton";

import styles from "./ViewEvent.module.css";

export default function AttachmentsRow({ attachments }: { attachments: EventExtraData["attachments"] }) {
	if (!attachments || attachments.length === 0) {
		return null;
	}

	return (
		<div className={styles.infoRow}>
			<div className={styles.infoRow__icon}>
				<FontAwesomeIcon fixedWidth icon={faPaperclip} style={{ marginTop: "4px" }} />
			</div>
			<div className={styles.infoRow__text}>
				{attachments.map(attachment => (
					<div key={attachment.fileId}>
						<a href={attachment.url} target="_blank" rel="noopener noreferrer" title={attachment.title || undefined}>
							<div className={styles.attachment}>
								<RecordingsIcon provider={attachment.provider} />

								<div className={styles.attachment__text}>{attachment.title}</div>
							</div>
						</a>
					</div>
				))}
			</div>
		</div>
	);
}
